import { Application, Case, CaseStatus } from '@bybeam/platform-types';

export default function isApplicationUneditable(
  application: Application & { case: Case },
): boolean {
  const { status } = application.case;
  return (
    ![CaseStatus.InProgress, CaseStatus.Incomplete, CaseStatus.Withdrawn].includes(status) ||
    (status === CaseStatus.Withdrawn && !!application.submittedAt)
  );
}
